import React from 'react';
import { useNavigate } from 'react-router-dom';
import WaitlistSection from '../components/WaitlistSection';
import './Home.css';

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="home">
      {/* Hero */}
      <section className="hero">
        <div className="hero-content">
          <h1>Bid on any home.<br /><span>Listed or not.</span></h1>
          <p className="hero-sub">
            Homes4Bid is the first marketplace where buyers can bid on any property —
            and homeowners can receive and respond to offers on their terms.
          </p>
          <div className="hero-search">
            <input
              type="text"
              placeholder="City, zip, neighborhood, or address"
              onKeyDown={e => e.key === 'Enter' && navigate('/search')}
            />
            <button className="btn btn-primary" onClick={() => navigate('/search')}>
              search homes
            </button>
          </div>
          <div className="hero-filters">
            {['all homes', 'active listings', 'accepting bids', 'off-market'].map(f => (
              <button key={f} className={`filter-chip ${f === 'all homes' ? 'active' : ''}`}
                onClick={() => navigate('/search')}>{f}</button>
            ))}
          </div>
        </div>
      </section>

      {/* How it works */}
      <section className="how-it-works">
        <div className="page">
          <h2 className="section-title">How it works</h2>
          <div className="steps-grid">
            <div className="step-card">
              <div className="step-icon buyer-icon">🔍</div>
              <h3>For Buyers</h3>
              <div className="step-list">
                <div className="step-item"><span className="step-num">1</span><span>Search any neighborhood or address — listed or off-market</span></div>
                <div className="step-item"><span className="step-num">2</span><span>See Zillow Zestimate pricing context and comparable sales</span></div>
                <div className="step-item"><span className="step-num">3</span><span>Place a blind bid — other buyers can't see your offer</span></div>
                <div className="step-item"><span className="step-num">4</span><span>Get notified instantly when the owner responds</span></div>
              </div>
              <button className="btn btn-primary" onClick={() => navigate('/search')}>browse homes</button>
            </div>
            <div className="step-card">
              <div className="step-icon owner-icon">🏡</div>
              <h3>For Owners</h3>
              <div className="step-list">
                <div className="step-item"><span className="step-num">1</span><span>Claim your home and see buyer interest in your area</span></div>
                <div className="step-item"><span className="step-num">2</span><span>Get a recommended listing price based on real market data</span></div>
                <div className="step-item"><span className="step-num">3</span><span>List publicly, quietly, or invite-only — you're in control</span></div>
                <div className="step-item"><span className="step-num">4</span><span>Accept, counter, or decline bids privately on your dashboard</span></div>
              </div>
              <button className="btn btn-primary" onClick={() => navigate('/owner-list')}>list my home</button>
            </div>
          </div>
        </div>
      </section>

      {/* Feature highlights */}
      <section className="features">
        <div className="page">
          <h2 className="section-title">Why Homes4Bid</h2>
          <div className="features-grid">
            {[
              { icon: '🔒', title: 'Blind Bidding', desc: 'Your bid amount is private. Other buyers see that bids exist — never how much.' },
              { icon: '📊', title: 'Zestimate Pricing', desc: 'Every listing shows Zillow\'s Zestimate and comparable sales so you bid with confidence.' },
              { icon: '🏘️', title: 'Off-Market Access', desc: 'Browse and bid on homes that aren\'t for sale yet. Be first when an owner is ready.' },
              { icon: '✉️', title: 'Physical Letter Service', desc: 'Stand out with a certified letter mailed to the owner on your behalf. Starting at $9.' },
              { icon: '🔔', title: 'Your Notifications', desc: 'Choose in-app, email, or SMS. Get notified instantly when your bid status changes.' },
              { icon: '📈', title: 'Rental Platform', desc: 'Predict when rentals are coming available and bid in advance. Coming soon.' },
            ].map(f => (
              <div key={f.title} className="feature-card">
                <div className="feature-icon">{f.icon}</div>
                <h4>{f.title}</h4>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Owner CTA */}
      <section className="owner-cta">
        <div className="page">
          <div className="owner-cta-inner">
            <div>
              <h2>Are you a homeowner?</h2>
              <p>You don't have to list publicly to get offers. Claim your address, set a price threshold, and let buyers come to you — quietly.</p>
              <div style={{ display: 'flex', gap: 10, marginTop: 20, flexWrap: 'wrap' }}>
                <button className="btn btn-primary" onClick={() => navigate('/owner-list')}>claim my home</button>
                <button className="btn" onClick={() => navigate('/owner-dashboard')}>see buyer activity near me</button>
              </div>
            </div>
            <div className="owner-cta-stats">
              {[['142', 'buyers searching Houston'], ['11 days', 'avg to accepted bid'], ['$10.8k', 'above Zestimate, top bid']].map(([v, l]) => (
                <div key={l} className="cta-stat">
                  <div className="cta-stat-val">{v}</div>
                  <div className="cta-stat-lbl">{l}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <WaitlistSection />
    </div>
  );
}
